export default __webpack_public_path__ + "static/media/logo.fd3ca535.png";